import { render, staticRenderFns } from "./AssessToolDialog.vue?vue&type=template&id=72320fac&scoped=true"
import script from "./AssessToolDialog.vue?vue&type=script&lang=js"
export * from "./AssessToolDialog.vue?vue&type=script&lang=js"
import style0 from "./AssessToolDialog.vue?vue&type=style&index=0&id=72320fac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72320fac",
  null
  
)

export default component.exports